<template>
  <b-container>
    <b class="row">
      <b-col cols="12">
        <v-text-field append-icon="mdi-magnify" placeholder="Buscar..." color="#793980"></v-text-field>
        <div>
          <div class="newsletter">
            <h5 class="pt-5 title">Seguinos</h5>
            <div align-h="between">
              <v-btn icon href="https://www.facebook.com/InstaCash.ar/" target="_blank">
                <v-icon class="violetars">mdi-facebook</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-5"
                href="https://www.instagram.com/instacash.ar/"
                target="_blank"
              >
                <v-icon class="violetars">mdi-instagram</v-icon>
              </v-btn>
            </div>

            <h5 class="pt-5 title">Newsletter</h5>
            <v-text-field
              placeholder="Email..."
              class="mx-5 px-5"
              color="#793980"
              prepend-icon="mdi-email"
            ></v-text-field>
            <v-btn text x-large block class="violetars">
              SUSCRIBIRSE
              <v-icon right class="violetars">mdi-chevron-triple-right</v-icon>
            </v-btn>
          </div>
          <h5 class="pt-5">
            Posts recientes
            <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
          </h5>
          <v-card
            v-ripple="{ 'class': 'rippleBlog'}"
            :href="reciente.href"
            elevation="0"
            v-for="reciente in recientes"
            :key="reciente.id"
            class="my-5"
           shaped 
          > 
            <v-list-item two-line class="pl-0">
              <v-list-item-avatar class="my-0 pl-0" tile size="80" color="transparent">
                <v-img :src="reciente.portada"></v-img>
              </v-list-item-avatar>
              <v-list-item-content class="py-0">
                <v-list-item-title class="headline mb-1">{{reciente.titulo}}</v-list-item-title>
                <div class="overline mb-4">
                  SIGUIENTE POST
                  <v-icon>mdi-arrow-right</v-icon>
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-card>

          <h5 class="pt-5">
            Categorías
            <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
            <v-card
              v-ripple="{ 'class': 'rippleBlog'}"
              v-for="categoria in categorias"
              :img="categoria.portada"
              :key="categoria.nombre"
              :href="'/'+categoria.href"
              elevation="0"
            >
              <div class="filtroCAT">
                <v-card-text class="aling-self-center titular">
                  <h2>{{categoria.nombre}}</h2>
                </v-card-text>
              </div>
            </v-card>
          </h5>
          <h5 class="pt-5">
            Tags
            <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
          </h5>
          <v-btn
            text
            color="#793980"
            class="tags"
            v-for="tag in tags"
            :key="tag.nombre"
            :href="'tag/'+tag.nombre"
          >{{tag.nombre}}</v-btn>
          <h5 class="pt-5">
            Instagram
            <v-icon right class="violeta">mdi-chevron-triple-right</v-icon>
          </h5>
          <vue-instagram
            token="4209443243.1677ed0.0723b1d785474b75963f1b228c47d279"
            :count="5"
            :tags="['hashtag1', 'hashtag2']"
            mediaType="image"
          >
            <template v-slot:loading="props">
              <h1 v-if="props.loading" class="fancy-loading">Loading, please wait...</h1>
            </template>
            <template v-slot:feeds="props">
              <li class="fancy-list">{{ props.feed.link }}</li>
            </template>
            <template v-slot:error="props">
              <div class="fancy-alert">{{ props.error.error_message }}</div>
            </template>
          </vue-instagram>
        </div>
      </b-col>
    </b>
  </b-container>
</template>

<script>
import VueInstagram from "vue-instagram";

export default {
  name: "ColumnaDer",
  components: {
    VueInstagram
  },

  data: () => ({}),

  mounted() {
    this.$store.dispatch("categorias/listarCategorias");
    this.$store.dispatch("categorias/listarTags");
    this.$store.dispatch("entradas/recientes");
  },
  computed: {
    categorias() {
      return this.$store.getters["categorias/verCategorias"];
    },
    tags() {
      return this.$store.getters["categorias/verTags"];
    },
    recientes() {
      return this.$store.getters["entradas/verRecientes"];
    }
  }
};
</script>
